import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/Credits/Credits.tsx");
